module.exports = __webpack_public_path__ + "c048e120aef25d83be81ac098c8ad809.pdf";